var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4",staticStyle:{"height":"100%"}},[_c('portal',{attrs:{"to":"app-header"}},[_c('a',{staticClass:"mr-2",attrs:{"href":"https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode"}},[_vm._v(" mix-blend-mode MDN ")])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }